module.exports = __webpack_public_path__ + "img/stock1.433a3314.png";